import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ArtifactDetailsCredit {
  id: number;
  title: string;
  description: string;
  type: string;
  evidence_progress_id: number;
  associated_level: number;
}

export interface ArtifactDetailsArea {
  id: number;
  title: string;
  position: number;
  description: string;
  credits: ArtifactDetailsCredit[];
}

export interface ArtifactDetails {
  id: number;
  title: string;
  learnerId: string;
  description: string;
  created_at: string;
  educator_feedback?: string;
  is_reviewed: boolean;
  type: string;
  isGroupExperience: boolean;
  fileUrl: string;
  areas: ArtifactDetailsArea[];
  comments: any[];
  access_code_publish_date: string | null;
}

export interface ArtifactDetailsState {
  data: ArtifactDetails | null;
}

const initialState: ArtifactDetailsState = {
  data: null,
};

const artifactDetailsSlice = createSlice({
  name: "artifactDetails",
  initialState,
  reducers: {
    setArtifactDetailsRedux(state, action: PayloadAction<ArtifactDetails>) {
      state.data = action.payload;
    },
    clearArtifactDetails(state) {
      state.data = null;
    },
  },
});

export const { setArtifactDetailsRedux, clearArtifactDetails } = artifactDetailsSlice.actions;
export default artifactDetailsSlice.reducer;
